import api from '../api/axiosInstance';

export const eiapClusterService = {
  getAll: () => api.get('/api/eiap-cluster'),
  getById: (id: string) => api.get(`/api/eiap-cluster/${id}`),
};
